import { queryContracts, queryFolders, unHideContracts } from '@/services';
import { Contracts, ContractsQuery, FolderItem } from '@/types';
import { ControllerBase, defineViewModel } from '@/utils/bizify';

type PageData = {
  openHideModal: boolean;
  openMoveModal: boolean;
  checkedFolder: FolderItem;
  selectedContracts: any[];
  folders: { rows: FolderItem[]; totalContract?: number };
  contracts?: Contracts;
  contractsLoading?: boolean;
  contractsQuery: ContractsQuery;
};
class PageCtrl extends ControllerBase<PageData> {
  protected $data() {
    return {
      openHideModal: false,
      openMoveModal: false,
      checkedFolder: { folderName: '' },
      selectedContracts: [],
      folders: { rows: [], totalContract: 0 },
      contracts: {},
      contractsLoading: false,
      contractsQuery: {}
    };
  }

  setOpenHideModal = (openHideModal: boolean) => {
    this.state.openHideModal = openHideModal;
  };
  setOpenMoveModal = (openMoveModal: boolean) => {
    this.state.openMoveModal = openMoveModal;
  };
  onMove = (data: any) => {
    this.state.selectedContracts = data;
    this.state.openMoveModal = true;
  };
  onHide = (data: any) => {
    this.state.selectedContracts = data;
    this.state.openHideModal = true;
  };
  setCheckedFolder = (checkedFolder: FolderItem) => {
    this.state.checkedFolder = checkedFolder;
  };
  getFolders = () => {
    queryFolders().then((res) => {
      this.state.folders = res;
    });
  };
  getContracts = ({ folder, filter, page, keyword, contractType }: ContractsQuery): void => {
    this.state.contractsLoading = true;
    queryContracts({ folder, filter, page, keyword, contractType, hidden: true })
      .then((res) => {
        this.state.contracts = res;
        this.state.contractsLoading = false;
      })
      .catch(() => {
        this.state.contractsLoading = false;
      });
  };
  onHideConfirm = (toast: any) => {
    this.state.openHideModal = false;
    toast({
      variant: 'success',
      title: 'Success',
      description: `Contract${this.state.selectedContracts.length > 1 ? 's' : ''} has been hidden`
    });
  };
  unHideContracts = (ids: number[], toast: any) => {
    unHideContracts({ contracts: ids }).then(() => {
      toast({
        variant: 'success',
        title: 'Success',
        description: `Contract${this.state.selectedContracts.length > 1 ? 's' : ''} has been unhided`
      });
      this.getContracts({});
      this.getFolders();
    });
  };
}

export const vm = defineViewModel(PageCtrl);
